// Helper function to get site ID based on locale
export const getSiteIdForLocale = (locale: string): string => {
    switch (locale) {
        case 'en':
            return '2';
        case 'nl':
            return '1';
        default:
            return '1'; // Default to Dutch
    }
};
